import { VExpandTransition } from 'vuetify/lib/components/transitions';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { "data-qa": "appointment_form_confirmation" } },
    [
      !_vm.useAuthMt
        ? _c("UserAuthorization", {
            ref: "user-authorization",
            attrs: {
              persistent: "",
              "is-render-in-modal": "",
              "is-phone-readonly": Boolean(
                _vm.useAuthMt ? _vm.userPhoneV2 : _vm.userPhone
              ),
              "is-visible": !_vm.isPhoneConfirmed,
              "init-phone": _vm.useAuthMt ? _vm.userPhoneV2 : _vm.userPhone,
              "hook-before-submit-form": _vm.checkCodeRequestAvailability,
              "is-country-authorization": "",
            },
            on: {
              "authorization:requested": _vm.handleRequestConfirm,
              "authorization:confirmed": _vm.handlePhoneConfirmed,
              "authorization:just-confirmed": _vm.handlePhoneJustConfirmed,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isPhoneConfirmed || _vm.useAuthMt
        ? [
            _vm.isVisibleWarningInfoTelemed
              ? _c(
                  "div",
                  { staticClass: "mb-6" },
                  [
                    _c("AppointmentWarningInfoTelemed", {
                      attrs: { "data-qa": "apointment_warning_info_telemed" },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isTelemedMedical
              ? _c(VExpandTransition, [
                  _vm.isUnderagePatient
                    ? _c(
                        "div",
                        [
                          _c("BaseAlert", {
                            staticClass: "mb-4",
                            attrs: {
                              color: "text-error",
                              text: "Онлайн-приём несовершеннолетних пока не поддерживается",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("PaymentInfo"),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }